import { BottomSheet, Text, type UseModalState } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

interface Props {
  modalState: UseModalState;
  onSkip: () => void;
}

export function SkipScheduleOrientationModal(props: Props) {
  const { modalState, onSkip } = props;

  const { closeModal } = modalState;

  return (
    <BottomSheet modalState={modalState}>
      <Stack py={8} px={6} alignItems="center" spacing={6}>
        <Text align="center" variant="h4">
          You haven&apos;t picked a time for your Demo Shift yet
        </Text>

        <Text light variant="body1" align="center">
          Are you sure you want to skip? You can&apos;t book shifts until you complete the Demo
          Shift.
        </Text>

        <Stack spacing={4} width="100%" pt={2}>
          <Button
            variant="contained"
            sx={{
              borderRadius: 84,
            }}
            onClick={() => {
              closeModal();
            }}
          >
            Go Back
          </Button>

          <Button
            variant="outlined"
            sx={{
              borderRadius: 84,
            }}
            onClick={() => {
              onSkip();
              closeModal();
            }}
          >
            Skip
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
}
